<template>
	<div class="nav-link-wrapper account">
		<!--check-permission :user_uid="selectedAccount" area="profile"-->
			<div class="nav-link" :class="{ 'router-link-active' : matchAccount }" @click.stop="onNavLinkClick($event)">
				<svgicon name="user" :fill="false"></svgicon>
				<span>{{ $t('base.general.user_account') }}</span>
				<div class="dropdown-toggle">&#9662;</div>
			</div>
			<div class="dropdown-content" @transitionend="updateShadow">
					<router-link v-if="selectedAccount" :to="{ name: 'UserProfileAccount', params: { user_uid: selectedAccount } }">{{ $t('base.general.your_profile') }}</router-link>
			</div>
		<!--/check-permission-->
	</div>
</template>

<script>
export default {
	props: [
		'updateShadow',
		'onNavLinkClick'
	],
	computed: {
		selectedAccount () {
			return this.$store.state.user.selectedAccount
		},
		matchAccount () {
			return this.$route.path.match(/\/user\/account*/)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/NavigationAccount.vue